export enum WREX_IMAGE {
    /**
     * @value Upload from computer
     * @description The label of the dropdown option to upload and add as attachments some files from your computer in a post.
     */
    FROM_COMPUTER = 'FRONT.POST_DIALOG.ADD_ATTACHMENTS.FROM_COMPUTER',
    /**
     * @value Pick from media library
     * @description The label of the dropdown option to add as attachments some files from your the media library in a post.
     */
    FROM_MEDIA_LIBRARY = 'FRONT.POST_DIALOG.ADD_ATTACHMENTS.FROM_MEDIA_LIBRARY',
    /**
     * @value Image
     * @description The label of the submenu option to insert an image. The submenu title will give the context (insert or attach)
     */
    IMAGE_BUTTON_LABEL = 'WREX_IMAGE.BUTTON_LABEL',
    /**
     * @value Write a caption here
     * @description The placeholder of the image caption input when inserting an inline image in rich contribution (ie. articles).
     */
    IMAGE_CAPTION_PLACEHOLDER = 'FRONT.CONTRIBUTION.IMAGE.CAPTION.PLACEHOLDER',
    /**
     * @value Add alt text
     * @description Text found on the button to add an alternative text on an image.
     */
    INSERT_ALT_TEXT_ADD = 'WREX_IMAGE.INSERT_ALT_TEXT_ADD',
    /**
     * @value Edit alt text
     * @description Text found on the button to edit the alternative text message on an image.
     */
    INSERT_ALT_TEXT_EDIT = 'WREX_IMAGE.INSERT_ALT_TEXT_EDIT',
    /**
     * @value Insert image
     * @description text editor insert image button tooltip
     */
    INSERT_IMAGE = 'FRONT.TEXT_EDITOR.INSERT_IMAGE',
}
